import { render, staticRenderFns } from "./salesBill.vue?vue&type=template&id=6358f3f6&scoped=true"
import script from "./salesBill.vue?vue&type=script&lang=js"
export * from "./salesBill.vue?vue&type=script&lang=js"
import style0 from "./salesBill.vue?vue&type=style&index=0&id=6358f3f6&prod&scoped=true&lang=css"
import style1 from "./salesBill.vue?vue&type=style&index=1&id=6358f3f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6358f3f6",
  null
  
)

export default component.exports